// eslint-disable-next-line import/no-anonymous-default-export
export default ({ editSchema, children }) => {
  return children(editSchema);
};
